"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BaseApi_1 = tslib_1.__importDefault(require("../BaseApi"));
var index_1 = require("../../modules/authorize/index");
var axios_1 = tslib_1.__importDefault(require("axios"));
var contextParamsToHttpHeaders_1 = tslib_1.__importDefault(require("./contextParams/contextParamsToHttpHeaders"));
var contextParamsFromLocalStorage_1 = tslib_1.__importDefault(require("./contextParams/contextParamsFromLocalStorage"));
var authParamsMap = {
    accessToken: 'access_token',
    idToken: 'id_token',
    bffKey: 'Authorization',
};
var operationsToBFF = {
    checkoutBFFOperations: [
        'createMethodOfPayment',
        'getMethodOfPayments',
        'updateMethodOfPayment',
        'createCart',
        'updateCart',
        'checkout',
        'initiateCheckout',
        'checkoutStatus',
        'addPromotions',
        'removePromotions',
        'orderManagement',
        'logFECheckoutEvent',
        'couponDetails',
    ],
    digitalPricingBFFOperations: [
        'getCities',
        'getPricingV2_external',
        'getPricingByExternalId_external',
        'getNextInteraction_authState',
        'getNextInteraction_taxQuote',
        'getNextInteraction_mopDetails',
        'getNextInteraction_orderDetails',
    ],
};
var getBFFUrl = function (operationName) {
    if (operationsToBFF.checkoutBFFOperations.includes(operationName)) {
        return index_1.cheggCheckoutBffGraphQLUrl;
    }
    else {
        return index_1.cheggDigitalPricingBFFGraphQLUrl;
    }
};
var GraphApi = /** @class */ (function () {
    function GraphApi() {
    }
    GraphApi.doFetchPersistedQuery = function (operationName, variables) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, headers;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = getBFFUrl(operationName);
                        headers = this.getHeaders();
                        return [4 /*yield*/, axios_1.default.request({
                                url: url,
                                method: 'POST',
                                data: JSON.stringify({
                                    operationName: operationName,
                                    variables: variables,
                                }),
                                headers: headers,
                                withCredentials: index_1.authorizeParams.noCookie ? false : true,
                            }).catch(function (errorData) {
                                return BaseApi_1.default.handleException(errorData, operationName);
                            })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Log API Failure
     */
    GraphApi.getAbsoluteDomainUrl = function () {
        if (typeof window !== 'undefined' &&
            'location' in window &&
            'protocol' in window.location &&
            'host' in window.location) {
            return "".concat(window.location.protocol, "//").concat(window.location.host);
        }
        return '';
    };
    GraphApi.getUserAgent = function () {
        if (typeof window !== 'undefined' &&
            'navigator' in window &&
            'userAgent' in window.navigator) {
            return window.navigator.userAgent;
        }
        return '';
    };
    var _a;
    _a = GraphApi;
    GraphApi.doOneGraphQuery = function (data) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        return tslib_1.__generator(_a, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, axios_1.default.request({
                        url: index_1.cheggOneGraphUrl,
                        method: 'POST',
                        data: JSON.stringify(data),
                        headers: this.getHeaders(),
                        withCredentials: !(index_1.authorizeParams === null || index_1.authorizeParams === void 0 ? void 0 : index_1.authorizeParams.noCookie),
                    }).catch(function (errorData) {
                        return BaseApi_1.default.handleException(errorData, data.operationName);
                    })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    }); };
    GraphApi.getHeaders = function (extraAuthParams) {
        if (extraAuthParams === void 0) { extraAuthParams = null; }
        var siteUrl = BaseApi_1.default.getSiteUrl();
        var referrer = BaseApi_1.default.getReferralUrl();
        var headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ 'content-type': 'application/json;charset=UTF-8', 'apollographql-client-name': 'checkout-sdk', Authorization: 'unknown', Accept: 'application/json', 'X-CHEGG-USER-AGENT': GraphApi.getUserAgent() }, (siteUrl && { 'x-chegg-referrer': siteUrl })), (referrer && { 'x-chegg-referrer-url': referrer })), (0, contextParamsToHttpHeaders_1.default)((0, contextParamsFromLocalStorage_1.default)()));
        var authParams = index_1.authorizeParams
            ? tslib_1.__assign({}, index_1.authorizeParams) : {
            apiKey: 'unknown',
            bffKey: 'unknown',
        };
        authParams.bffKey = authParams.bffKey
            ? "Basic ".concat(authParams.bffKey) // have this be base 64 encoded
            : 'unknown';
        Object.keys(authParams).forEach(function (key) {
            /* istanbul ignore next */
            if (authParamsMap[key] && authParams[key]) {
                headers[authParamsMap[key]] = authParams[key];
            }
        });
        return headers;
    };
    return GraphApi;
}());
exports.default = GraphApi;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/API/GraphApi/index.js
// module id = 1324
// module chunks = 11